import React from 'react';
import { motion } from 'framer-motion';
import { PageHeader } from '../components/PageHeader';
import { FuelIcon, ZapIcon, BuildingIcon, PlaneIcon, WifiIcon, FactoryIcon, WheatIcon, LandmarkIcon, GlobeIcon } from 'lucide-react';
const industries = [{
  name: 'Oil & Gas',
  icon: FuelIcon,
  description: 'Environmental assessments, compliance monitoring, and oil spill contingency planning for upstream and downstream operations.'
}, {
  name: 'Power & Renewable Energy',
  icon: ZapIcon,
  description: 'EIA and ESMP for solar, hydro, and thermal power projects including mini-grid installations.'
}, {
  name: 'Infrastructure & Transportation',
  icon: BuildingIcon,
  description: 'Environmental studies for roads, bridges, railways, and urban development projects.'
}, {
  name: 'Aviation',
  icon: PlaneIcon,
  description: 'Air quality monitoring, meteorological studies, and environmental assessments for airports.'
}, {
  name: 'Telecommunications',
  icon: WifiIcon,
  description: 'Environmental audits and compliance support for telecom infrastructure rollouts.'
}, {
  name: 'Manufacturing & Industrial',
  icon: FactoryIcon,
  description: 'Environmental assessments and pollution control studies for manufacturing facilities.'
}, {
  name: 'Agriculture & Agro-processing',
  icon: WheatIcon,
  description: 'ESIA for agricultural hubs, processing zones, and agribusiness developments.'
}, {
  name: 'Government Development Projects',
  icon: LandmarkIcon,
  description: 'Environmental support for federal and state government infrastructure initiatives.'
}, {
  name: 'International Development Agencies',
  icon: GlobeIcon,
  description: 'Environmental audits and assessments for World Bank, AfDB, and other donor-funded projects.'
}];
export function IndustriesPage() {
  return <>
      <PageHeader title="Industries We Serve" subtitle="Delivering specialized environmental solutions across diverse sectors of the Nigerian economy." data-id="element-607" />

      <section className="py-20 bg-white" data-id="element-608">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-609">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-610">
            {industries.map((industry, idx) => <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.5,
            delay: idx * 0.05
          }} className="group bg-gesl-offWhite p-8 rounded-sm border-l-4 border-transparent hover:border-gesl-green hover:bg-white hover:shadow-lg transition-all duration-300" data-id="element-611">
                <div className="h-14 w-14 bg-white rounded-sm flex items-center justify-center mb-6 shadow-sm group-hover:bg-gesl-dark transition-colors duration-300" data-id="element-612">
                  <industry.icon className="h-7 w-7 text-gesl-green group-hover:text-white transition-colors duration-300" data-id="element-613" />
                </div>
                <h3 className="text-xl font-bold text-gesl-dark mb-3" data-id="element-614">
                  {industry.name}
                </h3>
                <p className="text-gray-600 leading-relaxed" data-id="element-615">
                  {industry.description}
                </p>
              </motion.div>)}
          </div>
        </div>
      </section>

      {/* Experience Banner */}
      <section className="py-16 bg-gesl-warmWhite" data-id="element-616">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-617">
          <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-618">
            <div data-id="element-619">
              <div className="text-4xl font-bold text-gesl-dark mb-2" data-id="element-620">200+</div>
              <div className="text-gray-600" data-id="element-621">Projects Completed</div>
            </div>
            <div data-id="element-622">
              <div className="text-4xl font-bold text-gesl-dark mb-2" data-id="element-623">9+</div>
              <div className="text-gray-600" data-id="element-624">Industry Sectors</div>
            </div>
            <div data-id="element-625">
              <div className="text-4xl font-bold text-gesl-dark mb-2" data-id="element-626">30+</div>
              <div className="text-gray-600" data-id="element-627">Years of Experience</div>
            </div>
          </div>
        </div>
      </section>
    </>;
}